import React from "react"
import styles from "./RecommendOffers.module.css"
import { RecommendOffer } from "./types"
import { useFavoriteToggle } from "./useFavoriteToggle"
import { FavoriteStarIcon } from "./icons"

type RecommendOfferCardProps = {
    offer: RecommendOffer
    analyticsLabel: string
}

export default function RecommendOfferCard({
    offer,
    analyticsLabel,
}: RecommendOfferCardProps) {
    const { isFavorite, isSubmitting, toggle } = useFavoriteToggle(offer.offerId)

    // 月収・休日・勤務地のうち表示する要素。2つ以下なら1行、3つなら「月収・休日」と「勤務地」の2行に分ける
    const chips = [offer.salaryLabel, offer.holidayLabel, offer.location].filter(
        (c): c is string => Boolean(c),
    )

    return (
        <div className={styles.card} data-view-label={analyticsLabel}>
            <img
                src={offer.image}
                alt={offer.imageAlt}
                className={styles.cardPhoto}
            />
            <div className={styles.cardBody}>
                <p className={styles.cardCategory}>{offer.category}</p>
                <p className={styles.cardTitle}>{offer.title}</p>
                {chips.length <= 2 ? (
                    <div className={styles.cardChips}>
                        {chips.map((c) => (
                            <span key={c} className={styles.chip}>
                                {c}
                            </span>
                        ))}
                    </div>
                ) : (
                    <>
                        <div className={styles.cardChips}>
                            {offer.salaryLabel && (
                                <span className={styles.chip}>{offer.salaryLabel}</span>
                            )}
                            {offer.holidayLabel && (
                                <span className={styles.chip}>{offer.holidayLabel}</span>
                            )}
                        </div>
                        <div className={styles.cardChips}>
                            <span className={styles.chip}>{offer.location}</span>
                        </div>
                    </>
                )}
                <div className={styles.cardActions}>
                    <button
                        type="button"
                        onClick={toggle}
                        disabled={isSubmitting}
                        aria-pressed={isFavorite}
                        className={[
                            styles.btnOutline,
                            isFavorite ? styles.btnOutlineActive : "",
                        ]
                            .filter(Boolean)
                            .join(" ")}
                        data-click-label={`${analyticsLabel}-気になる`}
                    >
                        気になる
                        <FavoriteStarIcon
                            className={styles.btnIcon}
                            filled={isFavorite}
                        />
                    </button>
                    <a
                        href={offer.href}
                        className={styles.btnFilled}
                        data-click-label={`${analyticsLabel}-詳細を見る-CTA`}
                    >
                        詳細を見る
                    </a>
                </div>
            </div>
        </div>
    )
}
